import { InjectionToken } from "@angular/core";
import { Resolve } from "@angular/router";
import { IPage } from "@zaeper/communication-lib";
import { IAppVersion } from "src/app/models/application-version/i-app-version";

export const appVersionPageResolverInjectionToken: InjectionToken<Resolve<IPage<IAppVersion>>> = new InjectionToken<Resolve<IPage<IAppVersion>>>( "digital-signage-developer-dashboard.AppVersionPageResolver" );
